const snapchatPayerOpen = document.querySelectorAll('.js-snapchat-player-open-btn');
const snapchatPayerClose = document.querySelectorAll('.js-snapchat-player-wrapper .snapchat-player-close-btn');
const snapchatPayerFullscreenTrigger = document.querySelectorAll('.js-snapchat-player-wrapper .snapchat-player-fullscreen-trigger');
if(snapchatPayerOpen){
    snapchatPayerOpen.forEach(button=>{
        button.addEventListener('click', function (){
            openSnapchatPlayer(button);
        })
    })
}
if(snapchatPayerClose){
    snapchatPayerClose.forEach(button=>{
        button.addEventListener('click', function (){
            closeSnapchatPlayer();
        })
    })
}
if(snapchatPayerFullscreenTrigger){
    snapchatPayerFullscreenTrigger.forEach(button=>{
        button.addEventListener('click', function (){
            fullscreenSwitch();
        })
    })
}

function openSnapchatPlayer(button){
    const snapchatPlayer = document.querySelector('.js-snapchat-player-wrapper');
    if(snapchatPlayer){
        const player = snapchatPlayer.querySelector('.snapchat-player');
        let lensId = button.dataset.lensId
        if(lensId &&  lensId != 'none'){
            window.sendInputToLens(lensId, (player.offsetWidth*1.5), (player.offsetHeight*1.5))
            window.sendLensSize((player.offsetWidth*1.5), (player.offsetHeight*1.5))
        }
        snapchatPlayer.classList.add('open');
        if(snapchatPlayer.closest('.product__lead--image-inner')){
            snapchatPlayer.closest('.product__lead--image-inner').classList.add('snapchat-player-active');
        }
    }
}
function closeSnapchatPlayer(){
    const snapchatPlayer = document.querySelector('.js-snapchat-player-wrapper');
    if(snapchatPlayer){
        snapchatPlayer.classList.remove('open');
        snapchatPlayer.classList.remove('open-fullscreen');
        if(snapchatPlayer.closest('.product__lead--image-inner')){
            snapchatPlayer.closest('.product__lead--image-inner').classList.remove('snapchat-player-active');
        }
        stopCameraStream();
    }
}
function fullscreenSwitch(){
    const playerWrapper = document.querySelector('.js-snapchat-player-wrapper');
    const player = playerWrapper.querySelector('.snapchat-player');
    const playerInner = playerWrapper.querySelector('.snapchat-player-inner');
    const playerHeight = player.offsetHeight;
    if(playerWrapper.classList.contains('open-fullscreen')){
        playerWrapper.classList.remove('open-fullscreen');
        document.body.classList.remove('disable-scroll');
        if(playerInner){
            playerInner.removeAttribute('style');
        }
        if(player){
            window.sendLensSize((player.offsetWidth*1.5), (player.offsetHeight*1.5))
        }
    }else{

        playerWrapper.classList.add('open-fullscreen');
        document.body.classList.add('disable-scroll');

        if(player){
            window.sendLensSize((player.offsetWidth*1.5), (player.offsetHeight*1.5))
        }
    }
}
function lensVariantChange(variantId){
    if(document.querySelector('.snapchat-player-wrapper.open')){
        const snapchatPlayer = document.querySelector('.js-snapchat-player-wrapper');
        if(snapchatPlayer.dataset.variantId != variantId){
            window.setColorId(variantId)
            console.log('Variant id:' + variantId)
            snapchatPlayer.dataset.variantId = variantId;
        }
    }

}
function setExperienceId(variantId){
    const snapchatPlayer = document.querySelector('.js-snapchat-player-wrapper');
    if(variantId && variantId != '0' && variantId != 0){
        if(snapchatPlayer.dataset.variantId != variantId) {
            console.log('Lens variant id:' + variantId)
            snapchatPlayer.dataset.variantId = variantId;
            if (document.querySelector(`input[type="radio"][value="${variantId}"]`)) {
                document.querySelector(`input[type="radio"][value="${variantId}"]`).click();
            }
        }
    }
}